// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1RGsf","productName":"Table_productName__3vVe0"};